import { withInstall } from '@zoryn/utils'
import Card from './src/card.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZCard: SFCWithInstall<typeof Card> = withInstall(Card)
export default ZCard

export * from './src/card'
export type { CardInstance } from './src/instance'
